// src/components/Analytics.js
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

const Analytics = () => {
  const { t } = useTranslation('general');
  
  useEffect(() => {
    // Check if user has accepted cookies
    const hasConsent = Cookies.get('CookieConsent') === 'true';
    
    if (!hasConsent) {
      console.log('Cookie consent not given - analytics disabled');
      return;
    }

    // Only initialize analytics in production or if explicitly enabled
    const shouldInitializeAnalytics = 
      process.env.REACT_APP_ENABLE_ANALYTICS === 'true' || 
      process.env.NODE_ENV === 'production';

    if (!shouldInitializeAnalytics) {
      console.log('Analytics disabled in development mode');
      return;
    }

    // Get environment-specific IDs
    const clarityId = process.env.REACT_APP_CLARITY_ID;
    const gaId = process.env.REACT_APP_GA_ID;

    // Initialize Microsoft Clarity if ID is provided
    if (clarityId) {
      const clarityScript = document.createElement('script');
      clarityScript.type = 'text/javascript';
      clarityScript.innerHTML = `
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");
      `;
      document.head.appendChild(clarityScript);
    }

    // Initialize Google Analytics if ID is provided
    if (gaId) {
      const gaScript = document.createElement('script');
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(gaScript);

      const gaConfigScript = document.createElement('script');
      gaConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}', {
          'anonymize_ip': true, // For GDPR compliance
        });
      `;
      document.head.appendChild(gaConfigScript);
    }

    // Cleanup function
    return () => {
      if (clarityId) {
        const clarityScript = document.querySelector('script[src*="clarity.ms"]');
        if (clarityScript) {
          document.head.removeChild(clarityScript);
        }
      }
      if (gaId) {
        const gaScript = document.querySelector('script[src*="googletagmanager.com"]');
        const gaConfigScript = document.querySelector('script:not([src]');
        if (gaScript) {
          document.head.removeChild(gaScript);
        }
        if (gaConfigScript) {
          document.head.removeChild(gaConfigScript);
        }
      }
    };
  }, []);

  return null;
};

export default Analytics;